import { Injectable, Component, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import {ConstituencyApi } from '../../../../theme/services/sdk';
import {BaToastNotificationService} from '../../../../theme/services/baToastNotification';

@Component({
  selector: 'app-constituencies',
  templateUrl: './constituencies.component.html',
  styleUrls: ['./constituencies.component.scss'],
  providers:[ConstituencyApi,BaToastNotificationService]
})

@Injectable()
export class ConstituenciesComponent implements OnInit {

  private constituencySource = new BehaviorSubject<object>({})
  constituency = this.constituencySource.asObservable();

  private constituenciesSource = new BehaviorSubject<object>([])
  constituencies = this.constituenciesSource.asObservable();

  private totalItemsSource = new BehaviorSubject<number>(0)
  total_items = this.totalItemsSource.asObservable();

  private pSource = new BehaviorSubject<number>(1) // first page
  p = this.pSource.asObservable();

  private itemsPerPageSource = new BehaviorSubject<number>(10)
  itemsPerPage = this.itemsPerPageSource.asObservable();// number of items per page

  private searchingSource = new BehaviorSubject<boolean>(false)
  searching = this.searchingSource.asObservable();

  private editedIdSource = new BehaviorSubject<number>(null)
  editedId = this.editedIdSource.asObservable();

  constructor(protected constituencyService:ConstituencyApi,private toast: BaToastNotificationService) { }

  ngOnInit() {
    this.getConstituencies(this.pSource.getValue());
    this.getCount();
  }

  refresh(){
    this.pSource.next(1);
    this.getConstituencies(this.pSource.getValue());
    this.editedIdSource.next(null);
    this.getCount();
  }

  getConstituencies(page: number){
    let skip = ( page - 1) * this.itemsPerPageSource.getValue();
    this.constituencyService.find({
      order: "id DESC",
      include: ['county'],
      limit: this.itemsPerPageSource.getValue(),
      skip: skip
    })
        .subscribe((res) => {
              this.constituenciesSource.next(res);
            },
            ((error) => {
              this.toast.error({
                heading: 'Error',
                text: 'Something went wrong. Reload to try again.',
                stack: 3
              });
            }))
  }

  getCount(){
    this.constituencyService.count().subscribe((res) => {
      if(res)
        this.totalItemsSource.next(res.count);
    })
  }

  search(term: string, page:number){
    let skip = ( page - 1) * this.itemsPerPageSource.getValue();
    this.constituencyService.search(term, this.itemsPerPageSource.getValue(), skip)
        .subscribe( results => {
              this.totalItemsSource.next(results.data.total);
              this.constituenciesSource.next(results.data.constituencies);
              this.searchingSource.next(false);
            },
            err => {
              this.toast.error({
                heading: 'Error',
                text: 'Something went wrong. Reload to try again.',
                stack: 3
              });
            })
  }

  updateConstituencySource(data){
    this.constituencySource.next(data);
    this.editedIdSource.next(data.id);
  }

  cancelSelected(){
    this.editedIdSource.next(null);
    this.constituencySource.next({});
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/localization/components/constituencies/constituencies.component.ts